import { observable, runInAction } from 'mobx';
import {
  IHistoryReceiveServices,
  HistoryReceiveModel,
  DetailHistoryReceiveModel,
  CancelConfirmStage,
  HistoryReceives,
} from 'services/historyReceive_sevieces';

export type historyReceiveStore = {
  historyReceiveResponse: {
    isSuccess: boolean;
    data: HistoryReceiveModel[];
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  detailHistoryResponse: {
    isSuccess: boolean;
    data: DetailHistoryReceiveModel | undefined;
  };
  editReceiveVoteResponse: {
    isSuccess: boolean;
    message: string;
  };
  cancelConfirmStage: {
    isSuccess: boolean;
    message: string;
  },
  syncReceive: {
    isSuccess: boolean,
    message: string
  }
};

export interface IHistoryReceivePresenter {
  createStore(): historyReceiveStore;
  getHistoryReceive(store: historyReceiveStore, data: object): Promise<void>;
  getDetailHistoryReceive(store: historyReceiveStore, id: string): Promise<void>;
  // sửa phiếu nhập kho
  editReceiveVote(store: historyReceiveStore, data: object): Promise<void>;
  // Hủy xác nhận hoàn thành công đoạn
  cancelConfirmStage(store: historyReceiveStore, data: CancelConfirmStage): Promise<void>;
  // Nhập lại kho
  syncReceive(store: historyReceiveStore, data: object): Promise<void>
  // Export lịch sử nhập kho
  exportExcelHistoryRecieve(data: object): Promise<void>;
}

export function createHistoryReceivesPresenter({
  historyReceiveServices,
}: {
  historyReceiveServices: IHistoryReceiveServices;
}): IHistoryReceivePresenter {
  return {
    createStore: (): historyReceiveStore =>
      observable({
        historyReceiveResponse: {
          isSuccess: false,
          data: [],
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        detailHistoryResponse: {
          isSuccess: false,
          data: undefined,
        },
        editReceiveVoteResponse: {
          isSuccess: false,
          message: '',
        },
        cancelConfirmStage: {
          isSuccess: false,
          message: ''
        },
        syncReceive: {
          isSuccess: false,
          message: ''
        }
      }),
    getHistoryReceive: async (store: historyReceiveStore, data: object) => {
      try {
        const result = await historyReceiveServices.getHistorySeceive(data);
        runInAction(() => {
          store.historyReceiveResponse.data = result.data;
          store.historyReceiveResponse.isSuccess = result.isSuccess;
          store.historyReceiveResponse.resultsCount = result.pagesCount ? result.pagesCount : 0;
          store.historyReceiveResponse.recordsTotal = result.recordsTotal ? result.recordsTotal : 0;
          store.historyReceiveResponse.pagesCount = result.pagesCount ? result.pagesCount : 0;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getDetailHistoryReceive: async (store: historyReceiveStore, id: string) => {
      try {
        const result = await historyReceiveServices.getDetailHistoryReceive(id);
        runInAction(() => {
          store.detailHistoryResponse.data = result.data;
          store.detailHistoryResponse.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    editReceiveVote: async (store: historyReceiveStore, data: object) => {
      try {
        const result = await historyReceiveServices.editReceveVote(data);
        runInAction(() => {
          store.editReceiveVoteResponse.isSuccess = result.isSuccess;
          store.editReceiveVoteResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    cancelConfirmStage: async (store: historyReceiveStore, data: CancelConfirmStage) => {
      try {
        const result = await historyReceiveServices.cancelConfirmStage(data);
        runInAction(() => {
          store.cancelConfirmStage.isSuccess = result.isSuccess;
          store.cancelConfirmStage.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    //Nhập lại kho
    syncReceive: async (store: historyReceiveStore, data: object) => {
      try {
        const result = await historyReceiveServices.syncReceive(data);
        runInAction(() => {
          store.syncReceive.isSuccess = result.isSuccess;
          store.syncReceive.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Export lịch sử nhập kho
    exportExcelHistoryRecieve: async (data) => {
      try {
        const result = await historyReceiveServices.exportExcelHistoryRecieve(data);
      } catch (error) {

      }
    }
  };
}
